import { Flex } from '@chakra-ui/react';

import { NeedAttention } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const AlertBar = ({ text, ...props }) => (
  <Flex alignItems="center" bg="alerts.bgNegative" borderRadius="8px" p={2} {...props}>
    <NeedAttention color="alerts.negative" boxSize="24px" mr={2} />
    <TextBodyMedium color="alerts.negative">{text}</TextBodyMedium>
  </Flex>
);

export { AlertBar };
